<app-card>
  <div left-content class="content-container">
    <div class="header">{{ "initialScreen.header" | translate }}</div>
    <app-slider
      [header]="'initialScreen.sliderTitle' | translate"
      [control]="amount"
    ></app-slider>
    <button (click)="handleButtonClick()" mat-flat-button color="primary">
      {{ "initialScreen.buttonText" | translate }}
    </button>
    <div class="disclaimer">{{ "initialScreen.disclaimer" | translate }}</div>
  </div>
</app-card>
